export default __webpack_public_path__ + "static/media/jrc.6af1bd8b.png";